var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ObudowyLista"}},[_c('div',{attrs:{"id":"content"}},[_c('h3',[_vm._v("Lista obudów")]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.obudowy,"sort-options":{
      enabled: true,
      initialSortBy: _vm.localSort
    },"search-options":{
      enabled: true,
      placeholder: 'Szukaj...'
    },"pagination-options":{
      enabled: true,
      mode: 'records',
      position: 'top',
      perPageDropdown: [40, 80, 100],
      dropdownAllowAll: false,
      nextLabel: '',
      prevLabel: '',
      rowsPerPageLabel: 'Ilość wierszy',
      ofLabel: 'z',
      pageLabel: 'strona',
      allLabel: 'Wszystko'
    },"styleClass":"vgt-table striped"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'img')?_c('span',{staticStyle:{"float":"left","margin":"0px"}},[_c('img',{staticStyle:{"max-width":"30px","max-height":"30px","cursor":"zoom-in"},attrs:{"src":'https://lib.pulsar.pl/img/montaz_central/' +
                props.row.symbol +
                '.jpg',"alt":""},on:{"click":function($event){(_vm.showDialog = true),
                  (_vm.sourceImg = props.row.symbol + '.jpg')}}})]):_vm._e()]}}])})],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event},"update:md-active":function($event){_vm.showDialog=$event}}},[_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.showDialog = false}}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("X")])])],1),_vm._v(" "),_c('img',{staticStyle:{"width":"max-content","height":"100%","margin":"0px auto","padding":"20px"},attrs:{"src":_vm.photo}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666de38a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ObudowyLista.vue
// module id = null
// module chunks = 